import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      'Arbre Généalogique Familial': 'Arbre Généalogique Familial',
      'Prénom': 'Prénom',
      'Nom': 'Nom',
      'Nom de jeune fille': 'Nom de jeune fille',
      'Date de naissance': 'Date de naissance',
      'Sexe': 'Sexe',
      'Statut marital': 'Statut marital',
      'Notes': 'Notes',
      'Ajouter': 'Ajouter',
      'Recherche': 'Recherche',
      'Tous': 'Tous',
      'Célibataire': 'Célibataire',
      'Marié(e)': 'Marié(e)',
      'Divorcé(e)': 'Divorcé(e)',
      'Veuf/Veuve': 'Veuf/Veuve',
      'Non renseigné': 'Non renseigné',
      'Supprimer': 'Supprimer',
      'Annuler': 'Annuler',
      'Enregistrer': 'Enregistrer',
      'Fermer': 'Fermer',
      'Fiche membre': 'Fiche membre',
      'Uploader un document (à venir)': 'Uploader un document (à venir)',
      'Exporter PDF/PNG (à venir)': 'Exporter PDF/PNG (à venir)',
      'Créer la relation': 'Créer la relation',
      'Parent': 'Parent',
      'Frère': 'Frère',
      'Sœur': 'Sœur',
      'Conjoint(e)': 'Conjoint(e)',
      'Aucun lien familial n\'a encore été créé. Voici la liste des membres :': 'Aucun lien familial n\'a encore été créé. Voici la liste des membres :',
      'Relations existantes :': 'Relations existantes :',
      'Supprimer ce membre ?': 'Supprimer ce membre ?',
      'Supprimer cette relation ?': 'Supprimer cette relation ?',
      'Cette action est irréversible.': 'Cette action est irréversible.',
      'Changer le thème': 'Changer le thème',
      'Langue': 'Langue',
    }
  },
  en: {
    translation: {
      'Arbre Généalogique Familial': 'Family Tree',
      'Prénom': 'First name',
      'Nom': 'Last name',
      'Nom de jeune fille': 'Maiden name',
      'Date de naissance': 'Birth date',
      'Sexe': 'Gender',
      'Statut marital': 'Marital status',
      'Notes': 'Notes',
      'Ajouter': 'Add',
      'Recherche': 'Search',
      'Tous': 'All',
      'Célibataire': 'Single',
      'Marié(e)': 'Married',
      'Divorcé(e)': 'Divorced',
      'Veuf/Veuve': 'Widowed',
      'Non renseigné': 'Not specified',
      'Supprimer': 'Delete',
      'Annuler': 'Cancel',
      'Enregistrer': 'Save',
      'Fermer': 'Close',
      'Fiche membre': 'Member details',
      'Uploader un document (à venir)': 'Upload a document (coming soon)',
      'Exporter PDF/PNG (à venir)': 'Export PDF/PNG (coming soon)',
      'Créer la relation': 'Create relation',
      'Parent': 'Parent',
      'Frère': 'Brother',
      'Sœur': 'Sister',
      'Conjoint(e)': 'Spouse',
      'Aucun lien familial n\'a encore été créé. Voici la liste des membres :': 'No family link has been created yet. Here is the list of members:',
      'Relations existantes :': 'Existing relations:',
      'Supprimer ce membre ?': 'Delete this member?',
      'Supprimer cette relation ?': 'Delete this relation?',
      'Cette action est irréversible.': 'This action is irreversible.',
      'Changer le thème': 'Change theme',
      'Langue': 'Language',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 